
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { NewsletterDialog } from "@/components/home/NewsletterDialog";
import { motion } from "framer-motion";

const PrideEventDirectory = () => {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <Header />
      <main className="flex-grow">
        <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black px-4 pt-16 pb-8">
          <div className="container mx-auto relative z-10">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="space-y-6 md:space-y-8 text-center lg:text-left order-2 lg:order-1"
              >
                <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight">
                  <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#9b87f5] to-[#D946EF]">
                    Sydney Mardi Gras
                  </span>{" "}
                  Directory
                </h1>
                
                <p className="text-lg md:text-xl lg:text-2xl text-gray-300 leading-relaxed max-w-xl mx-auto lg:mx-0">
                  Discover all the LGBTQIA+ events this Pride here. From vibrant parades to intimate gatherings, find your perfect Pride celebration.
                </p>

                <div className="flex flex-wrap justify-center lg:justify-start gap-4">
                  <Button
                    onClick={() => window.open("https://linktr.ee/slayevents", "_blank")}
                    className="relative bg-[#D946EF] hover:bg-[#C935DE] text-white px-8 py-6 rounded-full text-lg font-medium transition-all duration-300 ease-out hover:scale-105 hover:shadow-lg hover:shadow-[#D946EF]/25"
                  >
                    Browse Events
                  </Button>
                  <NewsletterDialog />
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="relative block order-1 lg:order-2"
              >
                <div className="relative aspect-[3/4] rounded-3xl overflow-hidden p-4 sm:p-6 md:p-8">
                  <img
                    src="https://cloudflare.slay.events/Slay_Linktree_page.png"
                    alt="Pride celebration"
                    className="object-contain w-full h-full rounded-2xl"
                  />
                </div>
              </motion.div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PrideEventDirectory;
